import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createRoot } from 'react-dom/client';
import FlashFundingSite from './flash_funding_website_v_1';
import './styles.css';
const container = document.getElementById('root');
const root = createRoot(container);
root.render(_jsx(FlashFundingSite, {}));
